import * as a from '@mitranim/js/all.mjs'
import * as dr from '@mitranim/js/dom_reg.mjs'
import * as c from './conf.mjs'
import * as u from './util.mjs'

/*
Caution: currently doesn't support subclassing, because we have code that relies
on finding this by tagname. TODO: search by class instead.
*/
export class Modal extends u.Elem {
  static customName = `a-modal`
  static {dr.reg(this)}

  constructor() {
    super()
    this.retask()
  }

  // TODO convert getters to methods.
  get overlay() {return u.nodeByAttr(this, `data-role`, `modal-overlay`)}
  get persistent() {return a.truthy(this.id)}
  get visible() {return this.persistent ? !this.hidden : this.isConnected}

  connectedCallback() {
    this.onclick = this.onClick
    this.onkeydown = this.onKeydown
    this.addEventListener(c.EVENT_MODAL_HIDE, this)
    if (`escapeClose` in this.dataset) {
      this.unlisten?.()
      this.unlisten = this.env.events.addEvent(`keydown`, this)
    }
    this.onShow()
  }

  disconnectedCallback() {
    this.unlisten?.()
    this.unlisten = undefined
    this.removeEventListener(c.EVENT_MODAL_HIDE, this)
    this.retask()
    this.updateBodyLock()
    u.preactClear(this)
  }

  handleEvent(eve) {
    switch (eve.type) {
      case c.EVENT_MODAL_HIDE: return a.eventKill(eve), this.hide(eve.detail)
      case `keydown`: return this.onKeydown(eve)
    }
    return undefined
  }

  onClick(eve) {
    // Tentative: prevent clicks from propagating outside.
    // May revise in the future.
    a.eventStop(eve)

    if (`overlayClose` in this.dataset && u.isAncestorOf(eve.target, this.overlay)) {
      a.eventKill(eve)
      this.hide()
    }
  }

  onKeydown(eve) {
    if (`escapeClose` in this.dataset && eve.key === c.KEY_ESCAPE && this.visible) {
      a.eventKill(eve)
      this.hide()
    }
  }

  #fut = undefined
  get task() {return (this.#fut ??= new u.Fut()).task}

  retask(val) {
    this.#fut?.resolve(val)
    this.#fut = undefined
  }

  toggle() {
    if (this.visible) this.hide()
    else this.show()
  }

  show() {
    this.moveToRoot()
    this.hidden = false
    this.onShow()
    return this
  }

  hide(val) {
    this.retask(val)

    if (this.persistent) {
      this.hidden = true
      this.moveToPrevParent()
      this.updateBodyLock()
      return
    }

    this.remove()
  }

  onShow() {
    if (this.visible) {
      this.updateBodyLock()
      if (`autofocus` in this.dataset) u.focusFirst(this)
    }
  }

  updateBodyLock() {
    document.body.classList.toggle(`body-lock`, this.constructor.someShown())
  }

  moveToRoot() {
    this.prevParent = this.parentNode
    document.body.appendChild(this)
  }

  moveToPrevParent() {
    if (!this.isConnected) return
    const tar = a.only(this.prevParent, a.isNode)
    if (tar && tar !== this.parentNode) tar.appendChild(this)
  }

  static someShown() {return a.truthy(this.shown())}
  static shown() {return u.sel(document, `a-modal:not([hidden])`)}
}
